import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import RiskFactorList from './RiskFactors/RiskFactorList';
import Accordion from '../../../BaseComponentWrappers/MotifAccordion';
import {labels} from '../../../../../util/utils';
import styled from 'styled-components';

function RiskTypeNotARomm() {
	const riskFactors = useSelector((store) => store.riskFactors);
	const riskFactorsNotaROMM =
		riskFactors?.length > 0
			? riskFactors?.filter((rf) => (rf.riskTypeId === null || rf.riskTypeId === 0) && rf.isNotMaterial)
			: [];
	const [isAccordionOpen, setIsAccordionOpen] = useState(true);

	return (
		<>
			<StyledRiskTypeListItem className="notrom-risklist">
				<Accordion
					open={isAccordionOpen}
					onOpen={(e) => {}}
					onClose={(e) => {}}
					onClick={(e) => setIsAccordionOpen(!isAccordionOpen)}
					accordionHeading={labels.notROMMHeader}
					stopPropagation
					useChevronIcon
				>
					{riskFactorsNotaROMM?.length > 0 ? (
						<RiskFactorList riskFactorsList={riskFactorsNotaROMM} />
					) : (
						<section className="empty-template">
							<span className="no-identifiedrisks">{labels.noRecordsAvailable}</span>
						</section>
					)}
				</Accordion>
			</StyledRiskTypeListItem>
		</>
	);
}

export default RiskTypeNotARomm;

const StyledRiskTypeListItem = styled.section`
	margin-bottom: var(--px-30);
	cursor: default;
	.empty-template {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: default;
		border-top: var(--px-1) solid var(--neutrals-200);
		.no-identifiedrisks {
			color: var(--neutrals-700);
			font-size: var(--px-14);
			padding: var(--px-24) 0;
		}
	}
`;
